export const urlMap: Record<string, string> = {
    baseDomain: 'nocowanie.pl',
    home: '/',
    search: '/',
    reservation: 'rezerwuj/',
    checkout: 'potwierdz/',
    summary: 'podsumowanie/',
    join: 'dolacz-do-nocowanie/',
    partnerContactForm: 'https://forms.gle/uXgbtt7vh7t47ha76',
    login: 'logowanie/',
    map: 'map/',
    campaignListing: 'kampania/',
    termsOfServicePositioning: '/info/regulaminy,610,id,610.html#regulamin-5',
};
